export const name: string = 'Cards';
export const group = 'Charting';
export const moduleName: string = 'pdc-widget-cards2';
export const icon: string = 'dashboard';
export const namespace: string = 'business-intelligence';
export const themeId: string = 'pdc-widget-cards2'; //VR: Theme ID (to SELECT and EXPAND it in Theme dialog)
